/**
 * Wraps all ContentModule components in a default container. If you want to
 * give all ContentModule views a sidebar for example, you would set that here.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';

import filterUtils from '../../../global/utils/filterUtils';

// import actions
import * as courseActions from '../../course/courseActions';
import * as nodeActions from '../../node/nodeActions';
import * as sceneActions from '../../scene/sceneActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import contentModule components
import ContentModuleTableOfContentsItem from './ContentModuleTableOfContentsItem.js.jsx';

// not updating links here because this should no longer be used with athens handling training
class ContentModuleTableOfContents extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match, selectedContentModule } = this.props;
    if(match.params.courseSlug) {
      dispatch(courseActions.fetchSingleBySlug(match.params.courseSlug)).then((action) => {
        // console.log(action);
        if(action.success) {
          dispatch(contentModuleActions.fetchListIfNeeded("_id", action.item._contentModules))
        }
      });
    }
    dispatch(nodeActions.fetchListIfNeeded("_contentModule", selectedContentModule._id, "toc", true)).then((action) => {
      let sceneIds = action.list.map(node => node._scene).filter(s => s); // remove nulls
      // console.log("debug 1", sceneIds.length)
      dispatch(sceneActions.fetchListIfNeeded("_id", sceneIds));
    });
  }

  render() {
    const {
      courseStore
      , hasValidCert
      , hideFollowUps
      , isConclusionPage
      , match
      , nodeStore
      , previouslyViewedNodeIds
      , selectedContentModule
      , sceneStore
      , contentModuleStore
      , visible
    } = this.props;

    // get selected course
    const course = courseStore.selected.getItem() || {};
    // sort contentModules in order of course._contentModules
    const contentModules = contentModuleStore.util.getList("_id", course._contentModules) || [];
    const sortedContentModules = contentModules && contentModules.length > 0 ? contentModules.sort((a,b) => course._contentModules.indexOf(a._id) - course._contentModules.indexOf(b._id)) : []
    // grab node list by selectedContentModule id
    const nodes = nodeStore.util.getList("_contentModule", selectedContentModule._id, "toc", true) || [];
    // grab scenes from all the nodes we get
    const sceneIds = nodes.map(node => node._scene).filter(s => s);
    const scenes = sceneStore.util.getList("_id", sceneIds) || [];
    // sort nodes by orderWeight
    const sortedNodes = filterUtils.sortByOrderWeight(nodes)

    let menuClass = classNames(
      'toc-menu'
      , { '-visible': visible }
    )
    return (
      <div className={menuClass}>
        <div className="-content" >
          <div className="-header">
            <em>Table of contents for course</em>
            { course && course.title ?
              <NavLink
                className="-course-title"
                to={`/my-studies/${match.params.studySlug}/courses/${match.params.courseSlug}`}
              >
                {course.title}
                <div className="-instructions">
                  <small><em>Go to course overview</em></small>
                </div>
              </NavLink>
              :
              null
            }
          </div>
          <div className="-tm-links">

            { sortedContentModules && sortedContentModules.length > 0 ?
              sortedContentModules.map((tm, i) =>
                tm._id === selectedContentModule._id ?
                  <div key={tm._id + i} className="-scene-links">
                    <NavLink
                      className="-tm-title"
                      to={`/my-studies/${match.params.studySlug}/courses/${match.params.courseSlug}/cms/${tm.slug}`}
                    >
                      <div>
                        <small><em><strong>Simulation #{i + 1} (current)</strong><span className="-instructions"> &mdash; go to overview</span></em></small><br/>
                        {tm.title}
                      </div>
                      <i className="fal fa-angle-down"/>
                    </NavLink>
                    { sortedNodes && scenes && sortedNodes.length > 0 && scenes.length > 0 ?
                      sortedNodes.map((sortedNode, j) =>
                        <ContentModuleTableOfContentsItem
                          courseSlug={match.params.courseSlug}
                          currentNodeId={match.params.nodeId}
                          hasValidCert={hasValidCert}
                          hideFollowUps={hideFollowUps}
                          isConclusionPage={isConclusionPage}
                          key={sortedNode._id + j}
                          node={sortedNode}
                          scenes={scenes}
                          selectedContentModule={selectedContentModule}
                          studySlug={match.params.studySlug}
                          visited={previouslyViewedNodeIds.includes(sortedNode._id)}
                        />
                      )
                      :
                      null
                    }
                  </div>
                :
                  <NavLink
                    className="-tm-link"
                    key={tm._id + i}
                    to={`/my-studies/${match.params.studySlug}/courses/${match.params.courseSlug}/cms/${tm.slug}`}
                  >
                    <div>
                      <small><em>Module #{i + 1} <span className="-instructions"> &mdash; go to overview</span></em></small><br/>
                      {tm.title}
                    </div>
                  </NavLink>
                )
              :
              <div className="-scene-links">
                <NavLink
                  className="-tm-title"
                  to={`/my-agenda/cms/${selectedContentModule.slug}`}
                >
                  <div>
                    <small><em><strong>Current Simulation </strong><span className="-instructions"> &mdash; go to overview</span></em></small><br/>
                    {selectedContentModule.title}
                  </div>
                  <i className="fal fa-angle-down"/>
                </NavLink>
                { sortedNodes && scenes && sortedNodes.length > 0 && scenes.length > 0 ?
                  sortedNodes.map((sortedNode, j) =>
                    <ContentModuleTableOfContentsItem
                      courseSlug={match.params.courseSlug}
                      currentNodeId={match.params.nodeId}
                      hasValidCert={hasValidCert}
                      hideFollowUps={hideFollowUps}
                      isConclusionPage={isConclusionPage}
                      key={sortedNode._id + j}
                      node={sortedNode}
                      scenes={scenes}
                      selectedContentModule={selectedContentModule}
                      studySlug={match.params.studySlug}
                      visited={previouslyViewedNodeIds.includes(sortedNode._id)}
                    />
                  )
                  :
                  null
                }
              </div>
            }
          </div>
        </div>
        <div className="-overlay"/>
      </div>
    )
  }
}

ContentModuleTableOfContents.propTypes = {
  dispatch: PropTypes.func.isRequired
  , hasValidCert: PropTypes.bool
  , hideFollowUps: PropTypes.func
  , isConclusionPage: PropTypes.bool
  , previouslyViewedNodeIds: PropTypes.array
  , selectedContentModule: PropTypes.object.isRequired
  , visible: PropTypes.bool
}

ContentModuleTableOfContents.defaultProps = {
  hasValidCert: false
  , hideFollowUps: null
  , isConclusionPage: false
  , previouslyViewedNodeIds: []
  , visible: false
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    courseStore: store.course
    , nodeStore: store.node
    , sceneStore: store.scene
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ContentModuleTableOfContents)
);



// WEBPACK FOOTER //
// modules/contentModule/components/ContentModuleTableOfContents.js.jsx